"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteButton = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _Localization = require("../Localization");
var _defaultTranslations = require("../constants/defaultTranslations");
var _TranslationKey = require("../models/TranslationKey");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
const DeleteButton = props => {
  const {
    onClick,
    dataTestId
  } = props;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
    container: true,
    spacing: 2,
    alignItems: "center",
    justifyContent: "flex-start",
    style: {
      order: 98
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Grid, {
      display: "flex",
      alignItems: "center",
      component: "label",
      sx: {
        cursor: 'pointer'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
        tabIndex: 0,
        variant: "text",
        size: "large",
        color: "primary",
        "data-testid": getTestId((0, _utils.camelCaseToKebabCase)(`${dataTestId}Button`)),
        sx: {
          marginLeft: '-11px'
        },
        onClick: onClick,
        onKeyDown: onClick,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Trashcan, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "body1",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          defaultMessage: _defaultTranslations.defaultTranslations.deleteAddress,
          id: _TranslationKey.TranslationKey.deleteAddress
        })
      })]
    })
  });
};
exports.DeleteButton = DeleteButton;
//# sourceMappingURL=DeleteButton.js.map